






























import { Component, Vue } from "vue-property-decorator";
import { inject } from "inversify-props";
import { IAuthService } from '@/interfaces/Services';
import { emailRules, required } from "@/utils/validation";
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

@Component({})
export default class RequestResetLinkCard extends Vue {
  @inject(DependencyIdentifiers.AuthService)
  private authService!: IAuthService;

  private step = 1;
  private isLoading = false;
  private formData = {
    email: ""
  };
  private get formConfig() {
    return {
      email: {
        label: this.$t("account.email"),
        rules: [
          required,
          ...emailRules
        ]
      }
    };
  }

  async submit() {
    // @ts-ignore
    if (!this.$refs.form.validate()) {
      return;
    }
    this.isLoading = true;

    try {
      await this.authService.passwordResetRequest(this.formData.email);
      this.step++;
    } catch (e) {
      alert(this.$t('account.passwordResetRequest.emailNotFound'));
    } finally {
      this.isLoading = false;
    }
  }
}
